import fetch from "cross-fetch"

import { getDefaultHeaders, handleErrors } from "core/api"
import endpoints from "core/endpoints"

class DictionariesAPI {
  fetchList() {
    return handleErrors(
      fetch(endpoints.dictionaries(), {
        method: "get",
        headers: getDefaultHeaders(),
      })
    )
  }
}

export default new DictionariesAPI()
